<template>
  <v-card style="height: 100%;">
    <v-layout style="flex-direction: column; height: 100%;">
      <ExecutionResultsDialog ref="executionResultsDialog" />
      <ResultsHeader :viewer="$refs.viewer" @refresh="loadResults()" />
      <v-divider />
      <v-flex style="flex-grow: 1;">
        <v-layout style="height: 100%;">
          <v-flex md8 lg8 style="position: relative;">
            <PlaceholderView />
            <component v-bind:is="currentView" v-show="!states.loadingResults && !states.errorResults" ref="viewer" />
          </v-flex>
          <v-flex md4 lg4 class="divider-left">
            <v-card style="height: 100%;" color="#fafafa" flat>
              <ButtonCounts class="pb-1" />

              <v-divider />
              <v-tabs dense mandatory v-model="stepper" centered grow icons-and-text color="transparent" slider-color="success" active-class="success--text text--darken-1">
                <v-tab :href="`#${STEPPERS.review}`" ripple>
                  <span class="text-none">Submission Logs</span>
                  <v-icon large :color="stepper == STEPPERS.review ? 'success' : ''">pending_actions</v-icon>
                </v-tab>
                <v-divider vertical />
                <v-tab v-if="isTenantAdmin" :href="`#${STEPPERS.resubmit}`" ripple>
                  <span class="text-none">Current Changes</span>
                  <v-icon large :color="stepper == STEPPERS.resubmit ? 'success' : ''">history</v-icon>
                </v-tab>
              </v-tabs>
              <v-divider />

              <v-tabs-items v-model="stepper">
                <v-tab-item :value="STEPPERS.review">
                  <v-layout fill-height column v-if="stepper == STEPPERS.review">
                    <Review ref="review" />
                  </v-layout>
                </v-tab-item>
                <v-tab-item :value="STEPPERS.resubmit">
                  <v-layout fill-height column v-if="stepper == STEPPERS.resubmit">
                    <Changes />
                  </v-layout>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import ResultsHeader from './ResultsHeader'

  import PlaceholderView from './ViewTypes/PlaceholderView'
  import XLSXView from './ViewTypes/XLSXView'

  import HelpDialog from './HelpDialog'
  import Review from './Review/Review'
  import Changes from './Changes'

  import ButtonCounts from './SummaryButtons/ButtonCounts'

  const app = createNamespacedHelpers('app')
  const ingestionResults = createNamespacedHelpers('reviewingestionresults')
  const authenticate = createNamespacedHelpers('authenticate')

  const STEPPERS = {
    review: 'messages',
    resubmit: 'changelog',
  }

  const VIEW_TYPES = {
    XLSX: { name: 'XLSXView' },
    CSV: { name: 'XLSXView' },
  }

  export default {
    components: {
      ResultsHeader,
      XLSXView,
      Changes,
      Review,
      PlaceholderView,
      HelpDialog,
      ButtonCounts,
    },
    props: {
      executionId: String,
    },
    data() {
      return {
        VIEW_TYPES,
        STEPPERS,
        stepper: STEPPERS.review,
        isSubmit: false,
        currentView: '',
      }
    },
    computed: {
      ...ingestionResults.mapGetters(['focusLocation', 'logs']),
      ...authenticate.mapGetters(['isTenantAdmin']),
      states: {
        get() {
          return this.$store.getters['reviewingestionresults/states']
        },
        set(val) {
          this.updateStates(val)
        },
      },
      hasErrors() {
        return this.errorLogs.length > 0
      },
      noErrors() {
        return () => this.errorLogs.length == 0
      },
      errorLogs() {
        if (!this.logs) {
          return []
        }

        return this.logs.filter(log => log.severity == 'error' && !log.ignore)
      },
    },
    watch: {
      async focusLocation(value) {
        if (value) this.stepper = STEPPERS.review

        await this.$nextTick()
        this.$refs.review.setFilterState(0)
      },
      hasErrors(val) {
        this.updateStates({
          canResubmit: !val,
        })
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...ingestionResults.mapActions(['loadExecutionResults', 'updateStates', 'resubmitData']),
      async loadResults() {
        this.states = {
          loadingResults: true,
          errorResults: false,
        }

        try {
          let executionResults = await this.loadExecutionResults({
            executionId: this.executionId,
          })

          this.renderResults(executionResults)

        } catch (error) {
          this.states = { errorResults: true }
          this.$refs.executionResultsDialog.show(error)
        }

        this.states = {
          loadingResults: false,
        }
      },
      async renderResults(executionResults) {
        let fileType = executionResults.FileType
        let viewType = VIEW_TYPES[fileType]

        if (!viewType) {
          throw 'This file type cannot be reviewed, sorry.'
        }

        this.currentView = viewType.name
        await this.$nextTick()
        this.$refs.viewer.initialize(executionResults.ParsedData)
      },
    },
    beforeDestroy() {
      this.$store.dispatch('reviewingestionresults/reset')
    },
    mounted() {
      this.loadResults()
    },
  }
</script>

<style>
  .ingestion-results-stepper {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
  }

  .ingestion-results-stepper .v-stepper__wrapper {
    height: 100% !important;
  }

  .action-background {
    background-color: #f3f3f3;
    border-top: 1px solid #ddd;
  }

  .stepper-content {
    background-color: #f3f3f3;
    height: 100%;
    border-top: 1px solid #ddd;
  }
</style>